export default __webpack_public_path__ + "static/media/manrope-semibold.e7cf6f3b.woff";